import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The InfoSmallerCompaniesParticipation's component.
 */
const InfoSmallerCompaniesParticipation = () => (
  <GridContainer padding="0 0 8px" spacing={2}>
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-SmallerCompaniesParticipation.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que requieres consultar.</Item>
        <Item>Cantidad de ofertas enviadas a Licitaciones.</Item>
        <Item>Cantidad de Cotizaciones enviadas en Compra Ágil.</Item>
        <Item>Cantidad de Órdenes de compra.</Item>
        <Item>Cantidad de proveedores participando en Mercado Público.</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default InfoSmallerCompaniesParticipation
